module.exports = __webpack_public_path__ + "img/finera.f1436b1e.png";